module.exports = __webpack_public_path__ + "img/history-five.018b33f3.png";